import { render, staticRenderFns } from "./HealthSleepPanel.vue?vue&type=template&id=65e9e13f&"
import script from "./HealthSleepPanel.vue?vue&type=script&lang=ts&"
export * from "./HealthSleepPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports